import React from 'react';
import { g_HttpReq } from '../utils/httpUtils';

// /////////////////////////////////////////////////////////////////////////////////////////////
// Tags ////////////////////////////////////////////////////////////////////////////////////////
// /////////////////////////////////////////////////////////////////////////////////////////////
const tagsPrefix = '/tags';

class apiTags {
  async apiTagsGet(props = {}) {
    const { filterByUserTags } = props;
    const params = filterByUserTags ? { filterByUserTags } : {};
    return g_HttpReq.fetchGetJson(tagsPrefix, params);
  }

  // /////////////////////////////////////////////////////////////////////////////////////////////
  async apiTagCreate(props = {}) {
    return g_HttpReq.fetchPostJson(tagsPrefix, props);
  }

  // /////////////////////////////////////////////////////////////////////////////////////////////
  async apiTagDelete(entityId) {
    return g_HttpReq.fetchDeleteJson(tagsPrefix + '/' + encodeURIComponent(entityId), null);
  }

  // /////////////////////////////////////////////////////////////////////////////////////////////
  async apiTagUpdate(props = {}) {
    const { entityId, tagValue } = props;
    if (!entityId || !tagValue) {
      return Promise.reject({ status: 400, statusText: `Missing required parameter entityId:${entityId} tagValue:${tagValue}` });
    }

    return g_HttpReq.fetchPatchJson(tagsPrefix + '/' + encodeURIComponent(entityId), { tagValue });
  }
}

const g_apiTags = new apiTags();
export default g_apiTags;
